import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
function AssignToCrate(props) {
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [recordCount, setRecordCount] = useState(props?.selectedLocation?.remaningQuantity); // For input
    const position = { of: "#accordion-containe2" };
    console.log("selectedLocation:", JSON.stringify(props.selectedLocation, null, 2));
    console.log("selectedCrate:", JSON.stringify(props.selectedCrate, null, 2));
    const handleGenerateClick = async () => {
        const count = parseInt(recordCount, 10);
        if (!count || count <= 0) {
            alert("Please enter a Quantity greater than 0.","Error");
            return;
        }
        const remaningQuantity = parseInt(props?.selectedLocation?.remaningQuantity, 10);
        if (count > remaningQuantity) {
            alert("Please enter a Quantity less or equal to Remaining Quantity","Error");
            return;
        }
        try {
            setLoadPanelVisible(true);
            const formData = new FormData();
            formData.append("qty", count);
            formData.append("crateId", props?.selectedCrate?.rowid);
            formData.append("locationId", props?.selectedLocation?.rowid);
            formData.append("headerId", props?.headerId);
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/im/Crate/EnterCrateQuantity`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${props.oidc.user.access_token}`,
                    },
                }
            );
            //alert("Crates generated successfully.");
            if (props.onClosePopup) {
                props.onClosePopup();
                props.RefereshGrid();
            }
        } catch (error) {
            console.error("Error:", error);
            // alert("An error occurred while generating crates.");
        } finally {

            setLoadPanelVisible(false);
        }
    };

    return (
        <div className="FormMt container-fluid" style={{ height: "96%", paddingTop: "0px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <div className="row">
                <div className="col-md-6">
                    <TextBox
                        id="crateCount"
                        placeholder="Used"
                        width="100%"
                        value={(props?.selectedLocation?.quantity - props?.selectedLocation?.remaningQuantity)}
                        mode="number"
                        labelMode='static'
                        label='Used'
                        stylingMode='outlined'
                        disabled={true}
                    />
                </div>
                <div className="col-md-6">
                    <TextBox
                        id="crateCount"
                        placeholder="Remaining Quantity"
                        width="100%"
                        value={props?.selectedLocation?.remaningQuantity}
                        mode="number"
                        labelMode='static'
                        label='Remaining Quantity'
                        stylingMode='outlined'
                        disabled={true}
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <TextBox
                        id="crateCount"
                        value={recordCount}
                        onValueChanged={(e) => setRecordCount(e.value)}
                        placeholder="Enter Quantity"
                        width="100%"
                        mode="number"
                        inputAttr={{ min: 1 }}
                        labelMode='static'
                        label='Quantity'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <Button
                        text="Ok"
                        type="default"
                        stylingMode="contained"
                        width={120}
                        onClick={handleGenerateClick}
                    />
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(AssignToCrate);
